import { render, staticRenderFns } from "./IconChevronsLeft.vue?vue&type=template&id=b31d2b62&scoped=true&"
import script from "./IconChevronsLeft.vue?vue&type=script&lang=ts&"
export * from "./IconChevronsLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31d2b62",
  null
  
)

export default component.exports